import { noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import BgImage from '@public/images/background-page-builder.png'
import BannerView from '@src/components/battle/demo/blocks/BannerView'
import BlockView from '@src/components/battle/demo/blocks/BlockView'
import { PageBuilderData } from '@src/types/pageBuilder'

const StyledContainer = styled(Box)`
  padding-bottom: 60px;
  background: url(${BgImage.src}) repeat;
`

const PaddingBox = styled(Box)`
  padding-left: 16px;
  padding-right: 16px;
`

const Blocks = styled(Box, noForwardProps)<{ __gapY?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ __gapY }) => __gapY ?? 60}px;
  margin-left: auto;
  margin-right: auto;
`

type Props = {
  data: PageBuilderData
}

const PageBuilderPage = ({ data }: Props) => {
  if (!data) {
    return null
  }

  return (
    <StyledContainer>
      {data.banner && (
        <BannerView
          title={data.banner.title}
          bannerSrc={data.banner.bannerSrc}
          mobileBannerSrc={data.banner.mobileBannerSrc}
        />
      )}
      <PaddingBox>
        <Blocks __gapY={data.layoutProps?.spaceY}>
          {data.blocks.map((block, index) => {
            const key = `${block.type}-${index}`

            return <BlockView key={key} block={block} />
          })}
        </Blocks>
      </PaddingBox>
    </StyledContainer>
  )
}

export default PageBuilderPage
